import { put, call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import Translator from "../../Translation/Translator";

export default function* chargeSnooze(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_SNOOZE_UPDATE_REQUEST
    })

    let requestPayload: any = {};
    if (action.payload) {
      requestPayload.snoozeDate = action.payload?.snoozeDate;
    }

    const res = yield call(Http.put, `charge/${action.payload?.chargeId}/snooze`, {...requestPayload});
    const charge: ChargeInterface = ChargeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_CHARGE_SNOOZE_UPDATE_SUCCESS,
      payload: {
        charge: charge
      }
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })
        
    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: charge?.isSnoozed ? Translator.trans("snackbar-message-charge-snooze-updated-successfully") : Translator.trans("snackbar-message-charge-unsnooze-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_SNOOZE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeSnooze() {
  yield takeEvery(Constants.GLOBAL_CHARGE_SNOOZE_UPDATE_START, chargeSnooze);
}
